








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

var mti_metadata_pb=require('../../../mti/metadata_pb.js');
var mti_store_ram_ram_status_pb=require('../../../mti/store/ram/ram_status_pb.js');
var mti_store_core_iii_core_iii_port_status_pb=require('../../../mti/store/core_iii/core_iii_port_status_pb.js');
var google_protobuf_timestamp_pb=require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.exportSymbol('proto.mti.store.core_iii.State',null,global);











proto.mti.store.core_iii.State=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.store.core_iii.State,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.store.core_iii.State.displayName='proto.mti.store.core_iii.State';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.store.core_iii.State.prototype.toObject=function(opt_includeInstance){
return proto.mti.store.core_iii.State.toObject(opt_includeInstance,this);
};











proto.mti.store.core_iii.State.toObject=function(includeInstance,msg){
var f,obj={
metadata:(f=msg.getMetadata())&&mti_metadata_pb.Metadata.toObject(includeInstance,f),
storeId:jspb.Message.getFieldWithDefault(msg,2,0),
serialNumber:jspb.Message.getFieldWithDefault(msg,3,""),
ramStatus:(f=msg.getRamStatus())&&mti_store_ram_ram_status_pb.RamStatus.toObject(includeInstance,f),
stateUuid:msg.getStateUuid_asB64(),
stateUpdatedAt:(f=msg.getStateUpdatedAt())&&google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance,f),
identifying:jspb.Message.getFieldWithDefault(msg,7,false),
charging:jspb.Message.getFieldWithDefault(msg,8,false),
powered:jspb.Message.getFieldWithDefault(msg,9,false),
deepSleep:jspb.Message.getFieldWithDefault(msg,10,false),
armed:jspb.Message.getFieldWithDefault(msg,11,false),
baseLifted:jspb.Message.getFieldWithDefault(msg,12,false),
baseLiftAlarming:jspb.Message.getFieldWithDefault(msg,13,false),
lostCommunication:jspb.Message.getFieldWithDefault(msg,14,false),
silentAlarming:jspb.Message.getFieldWithDefault(msg,31,false),
keyInserted:jspb.Message.getFieldWithDefault(msg,15,false),
keySerialNumber:jspb.Message.getFieldWithDefault(msg,16,""),
batteryLevel:jspb.Message.getFieldWithDefault(msg,17,0),
port1:(f=msg.getPort1())&&mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.toObject(includeInstance,f),
port2:(f=msg.getPort2())&&mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.toObject(includeInstance,f),
port3:(f=msg.getPort3())&&mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.toObject(includeInstance,f),
port4:(f=msg.getPort4())&&mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.toObject(includeInstance,f),
port5:(f=msg.getPort5())&&mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.toObject(includeInstance,f),
port6:(f=msg.getPort6())&&mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.toObject(includeInstance,f),
port7:(f=msg.getPort7())&&mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.toObject(includeInstance,f),
port8:(f=msg.getPort8())&&mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.toObject(includeInstance,f),
port9:(f=msg.getPort9())&&mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.toObject(includeInstance,f),
port10:(f=msg.getPort10())&&mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.toObject(includeInstance,f),
model:jspb.Message.getFieldWithDefault(msg,28,""),
hardwareVersion:jspb.Message.getFieldWithDefault(msg,29,""),
firmwareVersion:jspb.Message.getFieldWithDefault(msg,30,"")};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.store.core_iii.State.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.store.core_iii.State();
return proto.mti.store.core_iii.State.deserializeBinaryFromReader(msg,reader);
};









proto.mti.store.core_iii.State.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=new mti_metadata_pb.Metadata();
reader.readMessage(value,mti_metadata_pb.Metadata.deserializeBinaryFromReader);
msg.setMetadata(value);
break;
case 2:
var value=reader.readUint64();
msg.setStoreId(value);
break;
case 3:
var value=reader.readString();
msg.setSerialNumber(value);
break;
case 6:
var value=new mti_store_ram_ram_status_pb.RamStatus();
reader.readMessage(value,mti_store_ram_ram_status_pb.RamStatus.deserializeBinaryFromReader);
msg.setRamStatus(value);
break;
case 4:
var value=reader.readBytes();
msg.setStateUuid(value);
break;
case 5:
var value=new google_protobuf_timestamp_pb.Timestamp();
reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
msg.setStateUpdatedAt(value);
break;
case 7:
var value=reader.readBool();
msg.setIdentifying(value);
break;
case 8:
var value=reader.readBool();
msg.setCharging(value);
break;
case 9:
var value=reader.readBool();
msg.setPowered(value);
break;
case 10:
var value=reader.readBool();
msg.setDeepSleep(value);
break;
case 11:
var value=reader.readBool();
msg.setArmed(value);
break;
case 12:
var value=reader.readBool();
msg.setBaseLifted(value);
break;
case 13:
var value=reader.readBool();
msg.setBaseLiftAlarming(value);
break;
case 14:
var value=reader.readBool();
msg.setLostCommunication(value);
break;
case 31:
var value=reader.readBool();
msg.setSilentAlarming(value);
break;
case 15:
var value=reader.readBool();
msg.setKeyInserted(value);
break;
case 16:
var value=reader.readString();
msg.setKeySerialNumber(value);
break;
case 17:
var value=reader.readUint32();
msg.setBatteryLevel(value);
break;
case 18:
var value=new mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus();
reader.readMessage(value,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.deserializeBinaryFromReader);
msg.setPort1(value);
break;
case 19:
var value=new mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus();
reader.readMessage(value,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.deserializeBinaryFromReader);
msg.setPort2(value);
break;
case 20:
var value=new mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus();
reader.readMessage(value,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.deserializeBinaryFromReader);
msg.setPort3(value);
break;
case 21:
var value=new mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus();
reader.readMessage(value,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.deserializeBinaryFromReader);
msg.setPort4(value);
break;
case 22:
var value=new mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus();
reader.readMessage(value,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.deserializeBinaryFromReader);
msg.setPort5(value);
break;
case 23:
var value=new mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus();
reader.readMessage(value,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.deserializeBinaryFromReader);
msg.setPort6(value);
break;
case 24:
var value=new mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus();
reader.readMessage(value,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.deserializeBinaryFromReader);
msg.setPort7(value);
break;
case 25:
var value=new mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus();
reader.readMessage(value,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.deserializeBinaryFromReader);
msg.setPort8(value);
break;
case 26:
var value=new mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus();
reader.readMessage(value,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.deserializeBinaryFromReader);
msg.setPort9(value);
break;
case 27:
var value=new mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus();
reader.readMessage(value,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.deserializeBinaryFromReader);
msg.setPort10(value);
break;
case 28:
var value=reader.readString();
msg.setModel(value);
break;
case 29:
var value=reader.readString();
msg.setHardwareVersion(value);
break;
case 30:
var value=reader.readString();
msg.setFirmwareVersion(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.store.core_iii.State.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.store.core_iii.State.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.store.core_iii.State.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getMetadata();
if(f!=null){
writer.writeMessage(
1,
f,
mti_metadata_pb.Metadata.serializeBinaryToWriter);

}
f=message.getStoreId();
if(f!==0){
writer.writeUint64(
2,
f);

}
f=message.getSerialNumber();
if(f.length>0){
writer.writeString(
3,
f);

}
f=message.getRamStatus();
if(f!=null){
writer.writeMessage(
6,
f,
mti_store_ram_ram_status_pb.RamStatus.serializeBinaryToWriter);

}
f=message.getStateUuid_asU8();
if(f.length>0){
writer.writeBytes(
4,
f);

}
f=message.getStateUpdatedAt();
if(f!=null){
writer.writeMessage(
5,
f,
google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);

}
f=message.getIdentifying();
if(f){
writer.writeBool(
7,
f);

}
f=message.getCharging();
if(f){
writer.writeBool(
8,
f);

}
f=message.getPowered();
if(f){
writer.writeBool(
9,
f);

}
f=message.getDeepSleep();
if(f){
writer.writeBool(
10,
f);

}
f=message.getArmed();
if(f){
writer.writeBool(
11,
f);

}
f=message.getBaseLifted();
if(f){
writer.writeBool(
12,
f);

}
f=message.getBaseLiftAlarming();
if(f){
writer.writeBool(
13,
f);

}
f=message.getLostCommunication();
if(f){
writer.writeBool(
14,
f);

}
f=message.getSilentAlarming();
if(f){
writer.writeBool(
31,
f);

}
f=message.getKeyInserted();
if(f){
writer.writeBool(
15,
f);

}
f=message.getKeySerialNumber();
if(f.length>0){
writer.writeString(
16,
f);

}
f=message.getBatteryLevel();
if(f!==0){
writer.writeUint32(
17,
f);

}
f=message.getPort1();
if(f!=null){
writer.writeMessage(
18,
f,
mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.serializeBinaryToWriter);

}
f=message.getPort2();
if(f!=null){
writer.writeMessage(
19,
f,
mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.serializeBinaryToWriter);

}
f=message.getPort3();
if(f!=null){
writer.writeMessage(
20,
f,
mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.serializeBinaryToWriter);

}
f=message.getPort4();
if(f!=null){
writer.writeMessage(
21,
f,
mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.serializeBinaryToWriter);

}
f=message.getPort5();
if(f!=null){
writer.writeMessage(
22,
f,
mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.serializeBinaryToWriter);

}
f=message.getPort6();
if(f!=null){
writer.writeMessage(
23,
f,
mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.serializeBinaryToWriter);

}
f=message.getPort7();
if(f!=null){
writer.writeMessage(
24,
f,
mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.serializeBinaryToWriter);

}
f=message.getPort8();
if(f!=null){
writer.writeMessage(
25,
f,
mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.serializeBinaryToWriter);

}
f=message.getPort9();
if(f!=null){
writer.writeMessage(
26,
f,
mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.serializeBinaryToWriter);

}
f=message.getPort10();
if(f!=null){
writer.writeMessage(
27,
f,
mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus.serializeBinaryToWriter);

}
f=message.getModel();
if(f.length>0){
writer.writeString(
28,
f);

}
f=message.getHardwareVersion();
if(f.length>0){
writer.writeString(
29,
f);

}
f=message.getFirmwareVersion();
if(f.length>0){
writer.writeString(
30,
f);

}
};






proto.mti.store.core_iii.State.prototype.getMetadata=function(){
return(
jspb.Message.getWrapperField(this,mti_metadata_pb.Metadata,1));
};



proto.mti.store.core_iii.State.prototype.setMetadata=function(value){
jspb.Message.setWrapperField(this,1,value);
};


proto.mti.store.core_iii.State.prototype.clearMetadata=function(){
this.setMetadata(undefined);
};






proto.mti.store.core_iii.State.prototype.hasMetadata=function(){
return jspb.Message.getField(this,1)!=null;
};






proto.mti.store.core_iii.State.prototype.getStoreId=function(){
return jspb.Message.getFieldWithDefault(this,2,0);
};



proto.mti.store.core_iii.State.prototype.setStoreId=function(value){
jspb.Message.setProto3IntField(this,2,value);
};






proto.mti.store.core_iii.State.prototype.getSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,3,"");
};



proto.mti.store.core_iii.State.prototype.setSerialNumber=function(value){
jspb.Message.setProto3StringField(this,3,value);
};






proto.mti.store.core_iii.State.prototype.getRamStatus=function(){
return(
jspb.Message.getWrapperField(this,mti_store_ram_ram_status_pb.RamStatus,6));
};



proto.mti.store.core_iii.State.prototype.setRamStatus=function(value){
jspb.Message.setWrapperField(this,6,value);
};


proto.mti.store.core_iii.State.prototype.clearRamStatus=function(){
this.setRamStatus(undefined);
};






proto.mti.store.core_iii.State.prototype.hasRamStatus=function(){
return jspb.Message.getField(this,6)!=null;
};






proto.mti.store.core_iii.State.prototype.getStateUuid=function(){
return jspb.Message.getFieldWithDefault(this,4,"");
};







proto.mti.store.core_iii.State.prototype.getStateUuid_asB64=function(){
return jspb.Message.bytesAsB64(
this.getStateUuid());
};









proto.mti.store.core_iii.State.prototype.getStateUuid_asU8=function(){
return jspb.Message.bytesAsU8(
this.getStateUuid());
};



proto.mti.store.core_iii.State.prototype.setStateUuid=function(value){
jspb.Message.setProto3BytesField(this,4,value);
};






proto.mti.store.core_iii.State.prototype.getStateUpdatedAt=function(){
return(
jspb.Message.getWrapperField(this,google_protobuf_timestamp_pb.Timestamp,5));
};



proto.mti.store.core_iii.State.prototype.setStateUpdatedAt=function(value){
jspb.Message.setWrapperField(this,5,value);
};


proto.mti.store.core_iii.State.prototype.clearStateUpdatedAt=function(){
this.setStateUpdatedAt(undefined);
};






proto.mti.store.core_iii.State.prototype.hasStateUpdatedAt=function(){
return jspb.Message.getField(this,5)!=null;
};








proto.mti.store.core_iii.State.prototype.getIdentifying=function(){
return jspb.Message.getFieldWithDefault(this,7,false);
};



proto.mti.store.core_iii.State.prototype.setIdentifying=function(value){
jspb.Message.setProto3BooleanField(this,7,value);
};








proto.mti.store.core_iii.State.prototype.getCharging=function(){
return jspb.Message.getFieldWithDefault(this,8,false);
};



proto.mti.store.core_iii.State.prototype.setCharging=function(value){
jspb.Message.setProto3BooleanField(this,8,value);
};








proto.mti.store.core_iii.State.prototype.getPowered=function(){
return jspb.Message.getFieldWithDefault(this,9,false);
};



proto.mti.store.core_iii.State.prototype.setPowered=function(value){
jspb.Message.setProto3BooleanField(this,9,value);
};








proto.mti.store.core_iii.State.prototype.getDeepSleep=function(){
return jspb.Message.getFieldWithDefault(this,10,false);
};



proto.mti.store.core_iii.State.prototype.setDeepSleep=function(value){
jspb.Message.setProto3BooleanField(this,10,value);
};








proto.mti.store.core_iii.State.prototype.getArmed=function(){
return jspb.Message.getFieldWithDefault(this,11,false);
};



proto.mti.store.core_iii.State.prototype.setArmed=function(value){
jspb.Message.setProto3BooleanField(this,11,value);
};








proto.mti.store.core_iii.State.prototype.getBaseLifted=function(){
return jspb.Message.getFieldWithDefault(this,12,false);
};



proto.mti.store.core_iii.State.prototype.setBaseLifted=function(value){
jspb.Message.setProto3BooleanField(this,12,value);
};








proto.mti.store.core_iii.State.prototype.getBaseLiftAlarming=function(){
return jspb.Message.getFieldWithDefault(this,13,false);
};



proto.mti.store.core_iii.State.prototype.setBaseLiftAlarming=function(value){
jspb.Message.setProto3BooleanField(this,13,value);
};








proto.mti.store.core_iii.State.prototype.getLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,14,false);
};



proto.mti.store.core_iii.State.prototype.setLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,14,value);
};








proto.mti.store.core_iii.State.prototype.getSilentAlarming=function(){
return jspb.Message.getFieldWithDefault(this,31,false);
};



proto.mti.store.core_iii.State.prototype.setSilentAlarming=function(value){
jspb.Message.setProto3BooleanField(this,31,value);
};








proto.mti.store.core_iii.State.prototype.getKeyInserted=function(){
return jspb.Message.getFieldWithDefault(this,15,false);
};



proto.mti.store.core_iii.State.prototype.setKeyInserted=function(value){
jspb.Message.setProto3BooleanField(this,15,value);
};






proto.mti.store.core_iii.State.prototype.getKeySerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,16,"");
};



proto.mti.store.core_iii.State.prototype.setKeySerialNumber=function(value){
jspb.Message.setProto3StringField(this,16,value);
};






proto.mti.store.core_iii.State.prototype.getBatteryLevel=function(){
return jspb.Message.getFieldWithDefault(this,17,0);
};



proto.mti.store.core_iii.State.prototype.setBatteryLevel=function(value){
jspb.Message.setProto3IntField(this,17,value);
};






proto.mti.store.core_iii.State.prototype.getPort1=function(){
return(
jspb.Message.getWrapperField(this,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus,18));
};



proto.mti.store.core_iii.State.prototype.setPort1=function(value){
jspb.Message.setWrapperField(this,18,value);
};


proto.mti.store.core_iii.State.prototype.clearPort1=function(){
this.setPort1(undefined);
};






proto.mti.store.core_iii.State.prototype.hasPort1=function(){
return jspb.Message.getField(this,18)!=null;
};






proto.mti.store.core_iii.State.prototype.getPort2=function(){
return(
jspb.Message.getWrapperField(this,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus,19));
};



proto.mti.store.core_iii.State.prototype.setPort2=function(value){
jspb.Message.setWrapperField(this,19,value);
};


proto.mti.store.core_iii.State.prototype.clearPort2=function(){
this.setPort2(undefined);
};






proto.mti.store.core_iii.State.prototype.hasPort2=function(){
return jspb.Message.getField(this,19)!=null;
};






proto.mti.store.core_iii.State.prototype.getPort3=function(){
return(
jspb.Message.getWrapperField(this,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus,20));
};



proto.mti.store.core_iii.State.prototype.setPort3=function(value){
jspb.Message.setWrapperField(this,20,value);
};


proto.mti.store.core_iii.State.prototype.clearPort3=function(){
this.setPort3(undefined);
};






proto.mti.store.core_iii.State.prototype.hasPort3=function(){
return jspb.Message.getField(this,20)!=null;
};






proto.mti.store.core_iii.State.prototype.getPort4=function(){
return(
jspb.Message.getWrapperField(this,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus,21));
};



proto.mti.store.core_iii.State.prototype.setPort4=function(value){
jspb.Message.setWrapperField(this,21,value);
};


proto.mti.store.core_iii.State.prototype.clearPort4=function(){
this.setPort4(undefined);
};






proto.mti.store.core_iii.State.prototype.hasPort4=function(){
return jspb.Message.getField(this,21)!=null;
};






proto.mti.store.core_iii.State.prototype.getPort5=function(){
return(
jspb.Message.getWrapperField(this,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus,22));
};



proto.mti.store.core_iii.State.prototype.setPort5=function(value){
jspb.Message.setWrapperField(this,22,value);
};


proto.mti.store.core_iii.State.prototype.clearPort5=function(){
this.setPort5(undefined);
};






proto.mti.store.core_iii.State.prototype.hasPort5=function(){
return jspb.Message.getField(this,22)!=null;
};






proto.mti.store.core_iii.State.prototype.getPort6=function(){
return(
jspb.Message.getWrapperField(this,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus,23));
};



proto.mti.store.core_iii.State.prototype.setPort6=function(value){
jspb.Message.setWrapperField(this,23,value);
};


proto.mti.store.core_iii.State.prototype.clearPort6=function(){
this.setPort6(undefined);
};






proto.mti.store.core_iii.State.prototype.hasPort6=function(){
return jspb.Message.getField(this,23)!=null;
};






proto.mti.store.core_iii.State.prototype.getPort7=function(){
return(
jspb.Message.getWrapperField(this,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus,24));
};



proto.mti.store.core_iii.State.prototype.setPort7=function(value){
jspb.Message.setWrapperField(this,24,value);
};


proto.mti.store.core_iii.State.prototype.clearPort7=function(){
this.setPort7(undefined);
};






proto.mti.store.core_iii.State.prototype.hasPort7=function(){
return jspb.Message.getField(this,24)!=null;
};






proto.mti.store.core_iii.State.prototype.getPort8=function(){
return(
jspb.Message.getWrapperField(this,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus,25));
};



proto.mti.store.core_iii.State.prototype.setPort8=function(value){
jspb.Message.setWrapperField(this,25,value);
};


proto.mti.store.core_iii.State.prototype.clearPort8=function(){
this.setPort8(undefined);
};






proto.mti.store.core_iii.State.prototype.hasPort8=function(){
return jspb.Message.getField(this,25)!=null;
};






proto.mti.store.core_iii.State.prototype.getPort9=function(){
return(
jspb.Message.getWrapperField(this,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus,26));
};



proto.mti.store.core_iii.State.prototype.setPort9=function(value){
jspb.Message.setWrapperField(this,26,value);
};


proto.mti.store.core_iii.State.prototype.clearPort9=function(){
this.setPort9(undefined);
};






proto.mti.store.core_iii.State.prototype.hasPort9=function(){
return jspb.Message.getField(this,26)!=null;
};






proto.mti.store.core_iii.State.prototype.getPort10=function(){
return(
jspb.Message.getWrapperField(this,mti_store_core_iii_core_iii_port_status_pb.CoreIIIPortStatus,27));
};



proto.mti.store.core_iii.State.prototype.setPort10=function(value){
jspb.Message.setWrapperField(this,27,value);
};


proto.mti.store.core_iii.State.prototype.clearPort10=function(){
this.setPort10(undefined);
};






proto.mti.store.core_iii.State.prototype.hasPort10=function(){
return jspb.Message.getField(this,27)!=null;
};






proto.mti.store.core_iii.State.prototype.getModel=function(){
return jspb.Message.getFieldWithDefault(this,28,"");
};



proto.mti.store.core_iii.State.prototype.setModel=function(value){
jspb.Message.setProto3StringField(this,28,value);
};






proto.mti.store.core_iii.State.prototype.getHardwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,29,"");
};



proto.mti.store.core_iii.State.prototype.setHardwareVersion=function(value){
jspb.Message.setProto3StringField(this,29,value);
};






proto.mti.store.core_iii.State.prototype.getFirmwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,30,"");
};



proto.mti.store.core_iii.State.prototype.setFirmwareVersion=function(value){
jspb.Message.setProto3StringField(this,30,value);
};


goog.object.extend(exports,proto.mti.store.core_iii);